import { StoreRootState } from '..'
import { ImportDialogSateType } from 'slices/ToolsetSlice'

export const importDialogSelect = (state: StoreRootState): ImportDialogSateType => state.toolset.importDialog
